export default {
  atividade: state => state.atividade
};
